// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Services_wrapper__1Cp26","heading":"Services_heading__2lTqL","cards":"Services_cards__2RLup","card":"Services_card__3lFCw"};